import { render, staticRenderFns } from "./BuyPaymentQrcode.vue?vue&type=template&id=445a56c8&scoped=true&"
import script from "./BuyPaymentQrcode.vue?vue&type=script&lang=js&"
export * from "./BuyPaymentQrcode.vue?vue&type=script&lang=js&"
import style0 from "./BuyPaymentQrcode.vue?vue&type=style&index=0&id=445a56c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445a56c8",
  null
  
)

export default component.exports